import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../redux/auth-store";
import storage from "../../helpers/storage";
import { logRedirect } from "../../utils/performance";
import { DEFAULT_AUTH_HOME } from "../../constants/routes";

/** Protected routes — token/session check only; does not prefetch modules or lists. */
const AuthLock: React.FC<{
  children: React.ReactNode;
  adminOnly?: boolean;
}> = ({ children, adminOnly = false }) => {
  const location = useLocation();
  const { user, token: storeToken } = useAuthStore();
  const hasSession = !!(storeToken || storage.getToken());

  if (!hasSession) {
    logRedirect("AuthLock", "/login", "missing_token", {
      from: location.pathname,
    });
    return (
      <Navigate to="/login" replace state={{ from: location }} />
    );
  }

  if (adminOnly && user?.role_id !== 1) {
    logRedirect("AuthLock", DEFAULT_AUTH_HOME, "admin_only_denied", {
      from: location.pathname,
    });
    return <Navigate to={DEFAULT_AUTH_HOME} replace />;
  }

  return <>{children}</>;
};

export default AuthLock;
